import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgLayers = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="m10 1 10 6-10 6L0 7zm6.67 10L20 13l-10 6-10-6 3.33-2L10 15z"
      fill="currentColor"
    />
  </svg>
);
